export default __webpack_public_path__ + "static/media/awaiting7.a4a998c5.svg";